var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      ref: "userDropdown",
      attrs: {
        size: "sm",
        variant: "link",
        "toggle-class": "custom-v-dropdown",
        right: "",
        "no-caret": "",
        "no-flip": "",
      },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c(
                "a",
                {
                  staticClass: "btn btn-icon",
                  attrs: { href: "#", "data-toggle": "dropdown" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "bb-badge badge-rounded user-initials" },
                    [_vm._v(" " + _vm._s(_vm.currentUser.initials) + " ")]
                  ),
                  _c("span", { staticClass: "user-name" }, [
                    _vm._v(_vm._s(_vm.currentUser.fullName)),
                  ]),
                  _c("span", { staticClass: "caret" }, [
                    _c("i", { staticClass: "la la-angle-down" }),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          staticClass: "navi navi-hover min-w-md-200px",
          on: {
            click: function ($event) {
              return _vm.closeDropdown()
            },
          },
        },
        [
          _c(
            "router-link",
            { attrs: { to: { name: "profile" } } },
            [
              _c(
                "b-dropdown-text",
                { staticClass: "navi-item", attrs: { tag: "div" } },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "feather feather-user",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "22",
                        height: "22",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                        },
                      }),
                      _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } }),
                    ]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("menu.profile")) + " "),
                ]
              ),
            ],
            1
          ),
          _vm.$hasRole(_vm.acl.roles.owner) ||
          _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
          _vm.$hasPermission(_vm.acl.permissions.managePlace)
            ? _c(
                "router-link",
                { attrs: { to: { name: "settings" } } },
                [
                  _c(
                    "b-dropdown-text",
                    { staticClass: "navi-item", attrs: { tag: "div" } },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-settings",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "22",
                            height: "22",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "3" },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" " + _vm._s(_vm.$t("menu.settings")) + " "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-dropdown-text",
            {
              staticClass: "navi-item",
              attrs: { tag: "div" },
              on: {
                click: function ($event) {
                  return _vm.changeLanguage()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-globe",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "22",
                    height: "22",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                  _c("line", {
                    attrs: { x1: "2", y1: "12", x2: "22", y2: "12" },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z",
                    },
                  }),
                ]
              ),
              _vm._v(" " + _vm._s(_vm.currentLanguageName) + " "),
            ]
          ),
          _c(
            "b-dropdown-text",
            {
              staticClass: "navi-item",
              attrs: { tag: "div" },
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-log-out",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "22",
                    height: "22",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" },
                  }),
                  _c("polyline", { attrs: { points: "16 17 21 12 16 7" } }),
                  _c("line", {
                    attrs: { x1: "21", y1: "12", x2: "9", y2: "12" },
                  }),
                ]
              ),
              _vm._v(" " + _vm._s(_vm.$t("menu.logout")) + " "),
            ]
          ),
        ],
        1
      ),
      _c("ChangeLanguageModal", { ref: "changeLanguageModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }